/**
 * Layers: Popspin guard.
 *
 * Popspin's rule config lives in its own app and is set to "immediate", so the
 * wheel opens on load and locks body scroll. Two changes, applied by patching
 * the custom element once it is defined, without touching Popspin's code:
 *
 * 1. The automatic trigger (applyTriggerLogic) fires only once the visitor has
 *    scrolled a share of the page, or after a fallback delay. Manual opens
 *    (the side tab, ?showPopSpin=true) are untouched.
 * 2. show() no longer locks the body: the overflow style Popspin sets is
 *    cleared right after it sets it.
 *
 * Tunables live on the <html> element so the theme can set them from Liquid:
 * data-popspin-scroll (percent of scrollable height, default 35)
 * data-popspin-fallback (seconds before it opens anyway, default 45)
 */
(() => {
  const root = document.documentElement;
  const scrollShare = Math.max(0, Math.min(100, Number(root.dataset.popspinScroll) || 35)) / 100;
  const fallbackSeconds = Number(root.dataset.popspinFallback) || 45;

  customElements.whenDefined('spin-wheel-popup').then(() => {
    const proto = customElements.get('spin-wheel-popup').prototype;
    if (proto.__layersGuarded) return;
    proto.__layersGuarded = true;

    const originalShow = proto.show;
    proto.show = function () {
      const result = originalShow.apply(this, arguments);
      document.body.style.overflow = '';
      return result;
    };

    const originalTrigger = proto.applyTriggerLogic;
    proto.applyTriggerLogic = function () {
      const el = this;
      let fired = false;
      const fire = () => {
        if (fired) return;
        fired = true;
        window.removeEventListener('scroll', onScroll);
        clearTimeout(timer);
        // Run Popspin's own trigger in "immediate" mode from here.
        const rules = el.rules || {};
        const savedType = rules.triggerType;
        rules.triggerType = 'immediate';
        try {
          originalTrigger.call(el);
        } finally {
          rules.triggerType = savedType;
        }
      };
      const onScroll = () => {
        const max = document.documentElement.scrollHeight - window.innerHeight;
        if (max <= 0 || window.scrollY >= max * scrollShare) fire();
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      const timer = setTimeout(fire, fallbackSeconds * 1000);
    };
  });
})();
